import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Box, Button, Stack, Typography } from "@mui/material"

import type { ContextDevice } from "types/device.types"

import { getDevicesLabel } from "helpers/utils/devices"
import EntityLink from "widgets/common/EntityLink"

// The rest wait behind "+N more".
const VISIBLE_DEVICES = 3

const DevicesSection = ({ devices }: { devices: ContextDevice[] }) => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)

  const count = devices.length
  const visible = expanded ? devices : devices.slice(0, VISIBLE_DEVICES)
  const hidden = count - visible.length

  return (
    <Stack gap={1} paddingY={1.25}>
      <Typography color="text.secondary">
        {getDevicesLabel(count, undefined, t)}
      </Typography>
      {visible.map((device) => (
        <Box
          key={device.id}
          sx={{ display: "flex", minWidth: 0, "& > a": { display: "flex" } }}
        >
          <EntityLink entity="device" id={device.id} name={device.name} maxLines={1} />
        </Box>
      ))}
      {hidden > 0 && (
        <Button
          size="small"
          onClick={() => setExpanded(true)}
          sx={{ alignSelf: "flex-start", padding: 0, minWidth: 0, fontWeight: 600 }}
        >
          {`+${t("asset_context.MORE_DEVICES", { count: hidden })}`}
        </Button>
      )}
    </Stack>
  )
}

export default DevicesSection
